import url from './url';



export default url(() => '/tag-system/templates/new');
